(function () {
  var ltcSec = document.getElementById('ltc');
  if (!ltcSec) return;

  /* 長照區 cursor-following mask */
  ltcSec.addEventListener('mousemove', function (e) {
    var r = ltcSec.getBoundingClientRect();
    ltcSec.style.setProperty('--mx', ((e.clientX - r.left) / r.width * 100).toFixed(2) + '%');
    ltcSec.style.setProperty('--my', ((e.clientY - r.top) / r.height * 100).toFixed(2) + '%');
  });

  /* 數據成形：格線繪出 + 數字依序 tally + 落定脈衝（scoped to #ltc，避免與其他 section 的 .count 衝突） */
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var counters = ltcSec.querySelectorAll('.count');
  var ltcStats = ltcSec.querySelector('.ltc-stats');
  if (!counters.length) return;

  var countList = Array.prototype.slice.call(counters);

  function tally(el, delay) {
    var stat = el.closest ? el.closest('.stat') : null;
    var target = parseInt(el.dataset.to, 10) || 0;
    var dur = 1400, start = null;
    function tick(now) {
      if (start === null) start = now;
      var t = Math.min(1, (now - start) / dur);
      var eased = 1 - Math.pow(1 - t, 3);
      el.textContent = Math.round(target * eased);
      if (t < 1) { requestAnimationFrame(tick); }
      else { el.textContent = target; if (stat) stat.classList.add('tallied'); }
    }
    if (delay) { setTimeout(function () { requestAnimationFrame(tick); }, delay); }
    else { requestAnimationFrame(tick); }
  }

  if (reduce || !('IntersectionObserver' in window)) {
    countList.forEach(function (el) {
      el.textContent = el.dataset.to || '0';
      var s = el.closest && el.closest('.stat');
      if (s) s.classList.add('tallied');
    });
    if (ltcStats) ltcStats.classList.add('in');
    return;
  }

  var cio = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (!en.isIntersecting) return;
      if (ltcStats) ltcStats.classList.add('in');
      var idx = countList.indexOf(en.target);
      tally(en.target, 200 + (idx < 0 ? 0 : idx) * 170);
      cio.unobserve(en.target);
    });
  }, { threshold: 0.5 });

  countList.forEach(function (el) { cio.observe(el); });
})();
